import React, { useId } from 'react';

import { IIcons } from '../interfaces/icons';
import { getColorHelper } from '../utils/getColorHelpers';

export function Headset({
  fillColor = 'brandBlue',
  colorWeight = '900',
  size = '60',
  height,
  width,
  onClick,
  style,
  className,
}: IIcons) {
  const clipPathId = `headset-${useId().replace(/:/g, '')}`;
  const backgroundFill = getColorHelper(fillColor, colorWeight);
  const headsetStroke = getColorHelper('brandBlue', '200');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || size}
      height={height || size}
      fill="none"
      viewBox="0 0 60 60"
      onClick={onClick}
      style={style}
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <rect width="60" height="60" rx="30" fill={backgroundFill} />
        <path
          opacity="0.1"
          d="M24.6254 61.8112C24.9133 61.8112 25.2012 61.8112 25.3932 62C34.7988 59.5451 44.2043 56.5236 53.5139 53.1245L54.9536 51.4249C44.5882 55.2961 34.031 58.6953 23.3777 61.4335C23.7616 61.4335 24.2415 61.7167 24.6254 61.8112ZM42.5728 -0.506438C28.7523 8.27468 14.1641 15.8283 -0.904029 22.1545V23.4764C14.644 16.9614 29.6161 9.12446 43.7245 0.0600862L42.5728 -0.506438ZM2.64706 11.0129C2.35913 11.5794 2.07121 12.1459 1.87926 12.7124C12.1486 7.70816 22.13 2.13734 31.7276 -4H29.808C21.0743 1.57082 11.9567 6.76395 2.64706 11.2961M12.6285 55.7682C29.0402 51.4249 45.1641 45.6652 60.6161 38.6781C60.6161 38.3004 60.808 37.9227 60.904 37.5451V37.4506C45.0681 44.6266 28.6563 50.3863 11.7647 54.7296L12.8204 55.6738M5.71826 48.4034C24.8173 42.927 43.3406 35.5622 61 26.4979C61 26.1202 61 25.7425 60.808 25.3648C42.9567 34.5236 24.3375 41.9828 5.04644 47.4592C5.23839 47.7425 5.43034 48.1202 5.71826 48.4034ZM-0.808051 32.3519C17.6192 25.7425 35.3746 17.2446 52.0743 7.04721L51.3065 6.38627C34.7988 16.3004 17.2353 24.7039 -1 31.2189V32.3519M1.39938 40.6609C21.0743 34.4292 39.9814 26.1202 57.9288 16.0172C57.8328 15.6395 57.6409 15.3562 57.4489 14.9785C39.5975 25.0815 20.6904 33.2961 1.11145 39.5279L1.39938 40.6609Z"
          fill="white"
        />
        <path
          d="M18 28.6667H22C22.7072 28.6667 23.3855 28.9476 23.8856 29.4477C24.3857 29.9478 24.6667 30.6261 24.6667 31.3334V35.3334C24.6667 36.0406 24.3857 36.7189 23.8856 37.219C23.3855 37.7191 22.7072 38 22 38H20.6667C19.9594 38 19.2811 37.7191 18.781 37.219C18.281 36.7189 18 36.0406 18 35.3334V28.6667ZM18 28.6667C18 27.0908 18.3104 25.5304 18.9134 24.0745C19.5165 22.6186 20.4004 21.2957 21.5147 20.1814C22.629 19.0671 23.9519 18.1832 25.4078 17.5801C26.8637 16.9771 28.4241 16.6667 30 16.6667C31.5759 16.6667 33.1363 16.9771 34.5922 17.5801C36.0481 18.1832 37.371 19.0671 38.4853 20.1814C39.5996 21.2957 40.4835 22.6186 41.0866 24.0745C41.6896 25.5304 42 27.0908 42 28.6667M42 28.6667V35.3334C42 36.0406 41.719 36.7189 41.219 37.219C40.7189 37.7191 40.0406 38 39.3333 38H38C37.2928 38 36.6145 37.7191 36.1144 37.219C35.6143 36.7189 35.3333 36.0406 35.3333 35.3334V31.3334C35.3333 30.6261 35.6143 29.9478 36.1144 29.4477C36.6145 28.9476 37.2928 28.6667 38 28.6667H42Z"
          stroke={headsetStroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42 35.3333V38C42 39.4145 41.4381 40.771 40.4379 41.7712C39.4377 42.7714 38.0812 43.3333 36.6667 43.3333H30"
          stroke={headsetStroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="60" height="60" rx="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
